import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { PostCard } from "../components/PostCard";
import { api } from "../lib/api";

const BANNER =
  "https://images.unsplash.com/photo-1471877325906-aee7c2240b5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHx0aGVhdHJlJTIwc3RhZ2UlMjBzcG90bGlnaHR8ZW58MHx8fHwxNzgzMjIzNTk5fDA&ixlib=rb-4.1.0&q=85";

export default function Reviews() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts", { params: { type: "review" } })
      .then((r) => setPosts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Navbar />
      <section className="relative h-[50vh] min-h-[360px] flex items-end overflow-hidden">
        <img src={BANNER} alt="Spotlight in a dark theatre" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] to-[#1A1A1A]/30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-14 w-full">
          <p className="label-caps text-[#D4AF37] mb-4">From the stalls</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-light text-[#F7F5F0]">Theatre Reviews</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20" data-testid="reviews-list">
        {loading ? (
          <p className="text-[#737373]">Loading reviews…</p>
        ) : posts.length === 0 ? (
          <p className="text-[#737373]">No reviews published yet. Check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {posts.map((p, i) => <PostCard key={p.id} post={p} index={i} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
